import  * as React from "react";
import { observer } from "mobx-react";
import { ISvgTextParams } from "./ISvgTextParams";

@observer
export class SvgText extends React.Component<ISvgTextParams>{
    constructor(props: ISvgTextParams) {
        super(props, undefined);
    }

    render() {
        return <text 
            className="SvgText" 
            fill={this.props.fill} 
            fontSize={this.props.fontSize} 
            transform={`translate(${this.props.translateX},${this.props.translateY})`}>
                {this.props.unit}
            </text>;
    }
}
